import { axios } from './axios'

export const listEvmStandards = () => {
  return axios.get('/standards/evm')
}
